/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Bid_Amount_LabelInputs */

const en_directory_vibebids_bid_amount_label = /** @type {(inputs: Directory_Vibebids_Bid_Amount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bid amount in dollars`)
};

const zh_directory_vibebids_bid_amount_label = /** @type {(inputs: Directory_Vibebids_Bid_Amount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美元出价金额`)
};

/**
* | output |
* | --- |
* | "Bid amount in dollars" |
*
* @param {Directory_Vibebids_Bid_Amount_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_bid_amount_label = /** @type {((inputs?: Directory_Vibebids_Bid_Amount_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Bid_Amount_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_bid_amount_label(inputs)
	return zh_directory_vibebids_bid_amount_label(inputs)
});
export { directory_vibebids_bid_amount_label as "directory.vibebids.bid_amount_label" }